import env              from '../env';
import { UserSession }  from '../types';
import {
    readData,
    writeData
}                       from './StorageService';

export async function getSession(): Promise<UserSession> {
    const dealer = await readData('dealer');
    const token = await readData('token');
    const user = JSON.parse(window.atob(token.split('.')[1])).user;

    return {
        ...user,
        token,
        dealer
    };
}

export function setSession(value: string) {
    writeData(env.STORAGE_KEY, value);
}



// WEBPACK FOOTER //
// ./src/services/SessionService.ts